import React, { useState } from 'react';
import { Plus, Key, MoreVertical, X, Loader2 } from 'lucide-react';
import { Card, Button, StatusPill, SystemBadge } from '../components/ui/Primitives';
export function Accounts() {
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [connectingSystem, setConnectingSystem] = useState<string | null>(null);
  const [accounts, setAccounts] = useState([{
    id: 1,
    system: 'bonzo',
    name: 'Production Primary',
    status: 'success',
    lastUsed: '2 mins ago'
  }, {
    id: 2,
    system: 'ghl',
    name: 'Main Agency Account',
    status: 'success',
    lastUsed: 'Just now'
  }, {
    id: 3,
    system: 'five9',
    name: 'Outbound Dialing',
    status: 'success',
    lastUsed: '1 hour ago'
  }]);
  const handleConnect = (system: string) => {
    setConnectingSystem(system);
    setTimeout(() => {
      setAccounts(prev => [{
        id: Date.now(),
        system,
        name: `New ${system} Connection`,
        status: 'success',
        lastUsed: 'Just now'
      }, ...prev]);
      setConnectingSystem(null);
      setShowConnectModal(false);
    }, 1500);
  };
  return <div className="max-w-6xl mx-auto relative" data-id="element-84">
      {showConnectModal && <div className="absolute inset-0 z-50 flex items-center justify-center min-h-[400px]" data-id="element-85">
          <div className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm" onClick={() => !connectingSystem && setShowConnectModal(false)} data-id="element-86" />
          <Card className="w-[480px] p-6 relative z-10 shadow-2xl animate-in zoom-in-95" data-id="element-87">
            <div className="flex justify-between items-center mb-6" data-id="element-88">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-89">
                Connect New Account
              </h3>
              <button onClick={() => !connectingSystem && setShowConnectModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-90">
                <X className="w-4 h-4" data-id="element-91" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-92">
              {['bonzo', 'ghl', 'five9', 'salesforce'].map(sys => <div key={sys} className="flex items-center justify-between p-3 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors" data-id="element-93">
                  <div className="flex items-center gap-3" data-id="element-94">
                    <SystemBadge system={sys as any} showLabel={false} className="scale-125 origin-left" data-id="element-95" />
                    <span className="text-sm font-medium text-slate-900 capitalize" data-id="element-96">
                      {sys}
                    </span>
                  </div>
                  <Button variant="outline" size="sm" onClick={() => handleConnect(sys)} disabled={connectingSystem !== null} data-id="element-97">
                    {connectingSystem === sys ? <>
                        <Loader2 className="w-3 h-3 mr-2 animate-spin" data-id="element-98" />{' '}
                        Connecting...
                      </> : 'Connect'}
                  </Button>
                </div>)}
            </div>
          </Card>
        </div>}

      <div className="flex items-center justify-between mb-6" data-id="element-99">
        <div data-id="element-100">
          <h1 className="text-xl font-semibold text-slate-900" data-id="element-101">
            Connected Accounts
          </h1>
          <p className="text-sm text-slate-500" data-id="element-102">
            Manage API keys and authentication for external systems.
          </p>
        </div>
        <Button variant="primary" onClick={() => setShowConnectModal(true)} data-id="element-103">
          <Plus className="w-4 h-4 mr-2" data-id="element-104" /> Connect Account
        </Button>
      </div>

      <Card className="overflow-hidden" data-id="element-105">
        <table className="w-full text-left border-collapse" data-id="element-106">
          <thead className="bg-slate-50 border-b border-slate-200" data-id="element-107">
            <tr data-id="element-108">
              <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-109">
                Platform
              </th>
              <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-110">
                Account Name
              </th>
              <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-111">
                Status
              </th>
              <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-112">
                Last Used
              </th>
              <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider text-right" data-id="element-113">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-114">
            {accounts.map(acc => <AccountRow key={acc.id} system={acc.system} name={acc.name} status={acc.status} lastUsed={acc.lastUsed} data-id="element-115" />)}
          </tbody>
        </table>
      </Card>
    </div>;
}
function AccountRow({
  system,
  name,
  status,
  lastUsed
}: any) {
  const [menuOpen, setMenuOpen] = useState(false);
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-116">
      <td className="px-6 py-4" data-id="element-117">
        <div className="flex items-center gap-2" data-id="element-118">
          <SystemBadge system={system} showLabel={false} data-id="element-119" />
          <span className="text-sm font-medium text-slate-900 capitalize" data-id="element-120">
            {system}
          </span>
        </div>
      </td>
      <td className="px-6 py-4" data-id="element-121">
        <div className="text-sm text-slate-700" data-id="element-122">{name}</div>
        <div className="text-xs text-slate-500 font-mono mt-0.5 flex items-center gap-1" data-id="element-123">
          <Key className="w-3 h-3" data-id="element-124" /> ••••••••a8f2
        </div>
      </td>
      <td className="px-6 py-4" data-id="element-125">
        <StatusPill status={status} dot={false} data-id="element-126" />
      </td>
      <td className="px-6 py-4 text-sm text-slate-500" data-id="element-127">{lastUsed}</td>
      <td className="px-6 py-4 text-right relative" data-id="element-128">
        <button className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded-md transition-colors" onClick={() => setMenuOpen(!menuOpen)} data-id="element-129">
          <MoreVertical className="w-4 h-4" data-id="element-130" />
        </button>
        {menuOpen && <>
            <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} data-id="element-131" />
            <div className="absolute right-6 top-10 w-40 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50 animate-in fade-in zoom-in-95" data-id="element-132">
              <button className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50" onClick={() => setMenuOpen(false)} data-id="element-133">
                Rotate Token
              </button>
              <button className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50" onClick={() => setMenuOpen(false)} data-id="element-134">
                View Audit Log
              </button>
              <div className="h-px bg-slate-200 my-1" data-id="element-135" />
              <button className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50" onClick={() => setMenuOpen(false)} data-id="element-136">
                Disconnect
              </button>
            </div>
          </>}
      </td>
    </tr>;
}